<div class="container my-4">
  <div class="row justify-content-center">
    <div class="col-md-8">
      <div class="card">
        <div class="card-header text-center">
          <h5>Order Status Update</h5>
        </div>
        <div class="card-body">
          <mat-dialog-content>
            <div class="form-group mb-4">
              <label class="font-weight-bold">Order Number:</label>
              <p class="form-control-plaintext bg-light border rounded px-2">{{ ordernumber }}</p>
            </div>
            <div class="form-group mb-4">
              <label class="font-weight-bold">Status:</label>
              <select #value  [disabled]="isUpdatableStatus(orderStatus)" (change)="onStatusChange($event)" [(ngModel)]="orderStatus" class="form-control">
                <option value="1">Processing</option>
                <option value="2">Out for Delivery</option>
                <option value="3">Delivered</option>
                <option value="4">Pending</option>
                <option value="5">Cancelled</option>
              </select>
            </div>
            <div class="form-group" *ngIf="orderStatus==4 && selectedstatus==4">
              <label class="font-weight-bold">Remarks:</label>
              <textarea class="form-control" [(ngModel)]="Remarks" ></textarea>
            </div>
            <div class="d-flex justify-content-between" >
              <button class="btn btn-primary" (click)="updateStatus()" [disabled]="isDisabled">Update Status</button>
              <button class="btn btn-secondary" mat-button (click)="closeDialog()">Close</button>
            </div>
          </mat-dialog-content>
        </div>
      </div>
    </div>
  </div>
</div>
